export const TableauIconUrl = "https://www.tableau.com/favicon.ico";
